import { realBricksApi } from "../../utils/axiosInterceptors";
import { toastNotify } from '../../utils/toastNotify';
import { ERROR_CONNECTIONG_BANK_MESSAGE } from '../../utils/constant';


export const fetchTokenApi = async () => {
    const response = await realBricksApi.get(`/api/v1/user/plaid-link-token`);
    return response.data;
};

export const sendBankDetailApi = async (data) => {
    const response = await realBricksApi.post(`/api/v1/user/bank-funding-source`, data);
    return response.data;
};

export const verifyMicroDeposit = async (id = null) => {
    try {
        const payload = id ? id : {};
        const response = await realBricksApi.post('/api/v1/user/verify-micro-deposit', payload);
        return response.data;
    } catch (error) {
        if (error.response?.data?.message === 'BANK_ERROR') {
           toastNotify('error', ERROR_CONNECTIONG_BANK_MESSAGE);
        } else {
           toastNotify('error', error?.response?.data?.message);
        }
    }
}

export const manualVerifyMicroDeposit = async (data) => {
    const response = await realBricksApi.post('/api/v1/payment/manual-verify-micro-deposit', data)
    return response.data;
}

export const storePlaidError = async (data) => {
    const response = await realBricksApi.post('/api/v1/user/plaid-client-error',data)
    return response.data;
}